export enum AuthType {
  ACCOUNT_ACTIVATION_USING_PIN = 'ACCOUNT_ACTIVATION_USING_PIN',
  ACCOUNT_REGISTRATION_USING_PIN = 'ACCOUNT_REGISTRATION_USING_PIN',
  ACCOUNT_SIGN_IN_USING_PIN = 'ACCOUNT_SIGN_IN_USING_PIN',
  APPLICATION_ACTIVATION_USING_PIN = 'APPLICATION_ACTIVATION_USING_PIN',
  EDIT_DATA_USING_PIN = 'EDIT_DATA_USING_PIN',
  EDIT_PHONE_USING_PIN = 'EDIT_PHONE_USING_PIN',
}
